import { API_BASE_URL } from '@shared/config/api';

import { navigateTo } from '../lib/navigate-to';
import { AUTH_AUTHORIZE_ENDPOINT } from './endpoints';

const normalizeRedirectPath = (redirectPath: string) =>
	redirectPath.startsWith('/') ? redirectPath : `/${redirectPath}`;

const getRedirectUri = (redirectPath: string) => {
	const normalizedPath = normalizeRedirectPath(redirectPath);
	return new URL(normalizedPath, window.location.origin).toString();
};

const getAuthorizeUrl = (redirectPath: string) => {
	const authorizeUrl = new URL(AUTH_AUTHORIZE_ENDPOINT, API_BASE_URL);
	authorizeUrl.searchParams.set('redirect_uri', getRedirectUri(redirectPath));
	return authorizeUrl.toString();
};

/**
 * Инициирует cookie-based авторизацию прямым переходом по `/authorize`.
 */
export const requestAuthorize = (redirectPath = '/'): void => {
	navigateTo(getAuthorizeUrl(redirectPath));
};
